























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import Area from "@/models/coding/areaModel";
@Component
export default class FieldAreaBase extends BaseVue {
  protected id: number|null = null;
  protected loading = false;
  protected repository!: BaseRepository<Area>;
  protected name: any = '';
  protected model: Area | any = null;

  created() {
      this.id = Number.parseInt(this.$route.params.areaId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<Area>("Areas");
      this.getData();
    }
  }
  
  @Watch('model')
  onModelChange() {
     if (this.model) this.name = this.hasParent && this.model ? this.model.name : "---";
  }
  gotToList() {
    this.$router.push("/Area");
  }
  protected async getData() {
    try {
      this.loading = true;
      if(this.id)
        this.model = await this.repository.getById(this.id);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  get hasParent() {
    return !!this.$route.params.areaId;
  }
}
